import * as api from "../../api/userApi";
import * as types from "../actionTypes";
import { sendHttpRequest } from "./httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadUserInfo() {
  return async (dispatch, getState) => {
    let userInfo = getState().userInfo;

    if (userInfo.isLoaded || userInfo.loading || userInfo.error) return;

    try {
      dispatch({ type: types.LOAD_USER_INFO_STARTED });
      userInfo = await dispatch(sendHttpRequest(api.loadUserInfo()));
      const userMenus = await dispatch(sendHttpRequest(api.loadUserMenus()));
      const userAdditionalData = await dispatch(sendHttpRequest(api.loadUserAdditionalData()));
      const rez = { ...userInfo, userAdditionalData, menuItems: userMenus.menuItems };
      dispatch({ type: types.LOAD_USER_INFO_SUCCESS, payload: rez });
    } catch (error) {
      dispatch({ type: types.LOAD_USER_INFO_FAILED });
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
